import { Flex, Stack } from '@mantine/core';
import { ProfileCongratsMobile } from './ProfileCongratsMobile';
import { ProfileKnightHelmet } from './ProfileKninghtHelmet';
import { ProfileUnboxChest } from './ProfileUnboxChest';
export const ProfileCongratsInfo: React.FC = () => {
  return <Flex direction="column" h="100%" align="center" justify={{
    base: 'center',
    lg: 'start'
  }} p={{
    base: 20,
    lg: 10
  }}>
      <ProfileCongratsMobile />

      <Stack gap={48} mt={48} w={{
      base: '100%',
      sm: 369,
      lg: '100%'
    }}>
        <ProfileUnboxChest />
        <ProfileKnightHelmet />
      </Stack>
    </Flex>;
};